import type { ResellerPermission } from "@xop-any-time/shared";

import { useAuth } from "./AuthProvider.js";

/**
 * The signed-in person's effective permissions (spec F §6.3).
 *
 * RENDERING ONLY. Every write this app makes is refused or allowed by crm-api
 * from the live membership; a control hidden here is a courtesy, and a
 * control shown here can still be refused. The list comes from the BFF's
 * 60-second cache, so it can lag a change by up to a minute.
 */
export function usePermissions(): {
  permissions: ResellerPermission[];
  can: (key: ResellerPermission) => boolean;
} {
  const { permissions, can } = useAuth();
  return { permissions, can };
}
